import React from 'react';

const RawDiscogsView = ({ discogsRelease }) => {
  if (!discogsRelease) return null;

  return (
    <div className="bg-gray-100 p-4 rounded shadow text-sm">
      <h2 className="font-semibold mb-2 text-gray-700">Raw Discogs Data (Debug)</h2>
      <pre className="overflow-auto max-h-64 whitespace-pre-wrap">
        {JSON.stringify(discogsRelease, null, 2)}
      </pre>
    </div>
  );
};

export default RawDiscogsView;